import { render, staticRenderFns } from "./FormUserSchoolRoles.vue?vue&type=template&id=2acc43e2&"
import script from "./FormUserSchoolRoles.vue?vue&type=script&lang=js&"
export * from "./FormUserSchoolRoles.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports